import React, { useState, useEffect } from "react";
import { InputWrapper } from "../../pages/auth/Login.style";
import colors from "../../assets/colors.json";
import { AuthButton } from "../../pages/auth/Login.style";
import hostelApi from "../../services/hostel";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ErrorService from "../../services/errorService";

const AddHouse = ({
  edit = false,
  selectedHouse = {},
  getHouses,
  setOpenEditHouseModal,
  setOpenCreateHouseModal,
}) => {
  const [loading, setLoading] = useState(false);
  const { admToken } = useSelector((state) => state.auth);
  const [houseName, setHouseName] = useState({ name: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      name: houseName.name,
    };
    
    const editData = {
      name: houseName.name,
      id: selectedHouse.id,
    };
    
    try {
      setLoading(true);
      const res = await (edit
        ? hostelApi.EditCreatedHouse(admToken, editData)
        : hostelApi.addHouse(admToken, data));
      if (res?.status && res?.statusCode === 2) {
        toast.success(res.message);
        getHouses();
        !edit && setOpenCreateHouseModal(false);
        edit && setOpenEditHouseModal(false);
        setLoading(false);
      } else if (res?.status === 500 || res?.status === 400 || !res?.status) {
        ErrorService.displayErrorAlert(res);
        console.log(res);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (edit && selectedHouse) {
      setHouseName({
        name: selectedHouse.house_name || '',
      });
    }
  }, [edit, selectedHouse]);

  return (
    <section>
      <h1 className="text-[1.5rem] text-center border-b-[0.5px] border-gray-400 w-[calc(100%+18px)] lg:w-[calc(100%+79px)] -ml-[9px] lg:-ml-[39px] pb-5">
        {edit ? "Edit" : "Add"} House
      </h1>
      <form onSubmit={handleSubmit} className="mt-8">
        <div className="w-full">
          <InputWrapper>
            <label>House Name</label>
            <input
              type="text"
              name="name"
              value={houseName.name}
              className="w-full"
              onChange={(e) =>
                setHouseName({ ...houseName, name: e.target.value })
              }
            />
          </InputWrapper>
        </div>

        <AuthButton
          bg={colors.primary}
          disabled={loading}
          className="!rounded-md w-full"
          type="submit"
        >
          {loading ? "Loading..." : `${edit ? "Edit" : "Add"} House`}
        </AuthButton>
      </form>
    </section>
  );
};

export default AddHouse;
